// @greenlight-spec: decisions/0026-integration-catalog-and-connection-profiles.md
// @greenlight-spec: 28-it-dashboard-ui.md
/** Kind default for a pasted private-key PEM (`private_key_jwt`, `github_app`). */
export const PEM_SECRET_PLACEHOLDER = '-----BEGIN PRIVATE KEY-----';
/**
 * Empty-field example copy for a connection profile's secret. A seed override
 * wins; otherwise the credential kind (and token-endpoint method, when the
 * kind is `oauth_client_credentials`) supplies a vendor-neutral shape so the
 * register form never falls back to "ex: key or secret".
 */
export function secretPlaceholderFor(credentialKind, override, tokenEndpointAuthMethod) {
    if (override)
        return override;
    switch (credentialKind) {
        case 'api_key':
            return 'API key';
        case 'bot_token':
            return 'xoxb-…';
        case 'personal_access_token':
            return 'Personal access token';
        case 'service_account_json':
            return '{ …service account JSON }';
        case 'oauth_client_credentials':
            return tokenEndpointAuthMethod === 'private_key_jwt' ||
                tokenEndpointAuthMethod === 'github_app'
                ? PEM_SECRET_PLACEHOLDER
                : 'Client secret';
        case 'sql_password':
            return 'Database password';
        case 'service_principal':
        case 'oauth_client':
            return 'Client secret';
        case 'github_app':
            return PEM_SECRET_PLACEHOLDER;
        case 'oauth_token_exchange':
        case 'none':
            return undefined;
    }
}
export function catalogDisplayNamePlaceholder(displayName) {
    return `e.g. ${displayName} — Prod`;
}
export function catalogSlugPlaceholder(catalogKey) {
    return `e.g. ${catalogKey}-prod`;
}
//# sourceMappingURL=registration-copy.js.map